module.exports = __webpack_public_path__ + "static/media/Inky_NormaGoldhagen.07c0c2ff.png";